import React, { Component } from 'react';
import './intropart.css';
import desktop from "../../../../../assets/desktop.svg";

export default class Intropart extends Component {
    render() {
        return (
            <div>
                <div className="firstsec">
                    <div className="main">
                        <div className="txt">
                            <h1>
                                Theory<span>Dev</span>
                            </h1>
                            <p>
                                Facing difficulties with this virtually evolving world? Allow
                                us to provide you the solutions by rendering web development
                                services like Html, CSS, Java Script, React, etc.
                </p>
                        </div>
                        <img src={desktop} alt="" />
                    </div>
                </div>
            </div>
        )
    }
}
